import { create } from 'zustand'

type State = {
    fileName: string
    filePath: string
}

type Action = {
    updateFileName: (fileName: State['fileName']) => void
    updateFilePath: (filePath: State['filePath']) => void
}

const initialState: State = {
    fileName: '',
    filePath: ''
}

export const useCurrentFileStore = create<State & Action>()((set) => ({
    ...initialState,
    updateFileName: (fileName) => set(() => ({ fileName: fileName })),
    updateFilePath: (filePath) => set(() => ({ filePath: filePath })),
}))